module.exports = __webpack_public_path__ + "assets/img/Discover-Massage-Australia-eBook-w960.6cc026d0.jpg";